var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modal", class: { "is-active": _vm.active } },
    [
      _c("div", { staticClass: "modal-background" }),
      _vm._v(" "),
      _c("div", { staticClass: "modal-card" }, [
        _c("header", { staticClass: "modal-card-head" }, [
          _c("p", { staticClass: "modal-card-title" }, [
            _vm._v(_vm._s(_vm.$t("recommandation_title")))
          ])
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "modal-card-body" },
          [
            _c("div", { staticClass: "notification is-primary" }, [
              _vm._v(_vm._s(_vm.$t("intro_text")))
            ]),
            _vm._v(" "),
            _vm._l(_vm.newRecommendations, function(recommendation, key) {
              return _c("div", { key: key }, [
                _c("div", { staticClass: "columns" }, [
                  _c("div", { staticClass: "column is-5" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", {
                        staticClass: "label",
                        domProps: {
                          textContent: _vm._s(_vm.$t("contact_name_label"))
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "control has-icon has-icons-right" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: recommendation.name,
                                expression: "recommendation.name"
                              }
                            ],
                            class: {
                              input: true,
                              "is-danger": _vm.errors.has(
                                "newRecommendations." + key + ".name"
                              )
                            },
                            attrs: {
                              name: "newRecommendations." + key + ".name",
                              type: "text"
                            },
                            domProps: { value: recommendation.name },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  recommendation,
                                  "name",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "newRecommendations." + key + ".name"
                                  ),
                                  expression:
                                    "errors.has('newRecommendations.' + key + '.name')"
                                }
                              ],
                              staticClass: "icon is-right is-danger"
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-alert-circle mdi-24px"
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column is-5" }, [
                    _c("div", { staticClass: "field" }, [
                      _c("label", {
                        staticClass: "label",
                        domProps: {
                          textContent: _vm._s(_vm.$t("contact_email_label"))
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "control has-icon has-icons-right" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|email",
                                expression: "'required|email'"
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: recommendation.email,
                                expression: "recommendation.email"
                              }
                            ],
                            class: {
                              input: true,
                              "is-danger": _vm.errors.has(
                                "newRecommendations." + key + ".email"
                              )
                            },
                            attrs: {
                              name: "newRecommendations." + key + ".email",
                              type: "email"
                            },
                            domProps: { value: recommendation.email },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  recommendation,
                                  "email",
                                  $event.target.value
                                )
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.errors.has(
                                    "newRecommendations." + key + ".email"
                                  ),
                                  expression:
                                    "errors.has('newRecommendations.' + key + '.email')"
                                }
                              ],
                              staticClass: "icon is-right is-danger"
                            },
                            [
                              _c("i", {
                                staticClass: "mdi mdi-alert-circle mdi-24px"
                              })
                            ]
                          )
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "column is-2" }, [
                    key >= 2
                      ? _c("div", { staticClass: "field" }, [
                          _c("label", { staticClass: "label" }, [_vm._v(" ")]),
                          _vm._v(" "),
                          _c("p", { staticClass: "control" }, [
                            _c(
                              "button",
                              {
                                staticClass: "button is-danger is-outlined",
                                attrs: { disabled: _vm.isModalLoading },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.removeRecommendation(key)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("remove_doctor")))]
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ])
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "button is-info is-outlined mt-3",
                attrs: { disabled: _vm.isModalLoading },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.addRecommendation()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("add_another_doctor")))]
            )
          ],
          2
        ),
        _vm._v(" "),
        _c("footer", { staticClass: "modal-card-foot" }, [
          _c(
            "button",
            {
              staticClass: "button",
              attrs: { type: "button", disabled: _vm.isModalLoading },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.close()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("close_button_label")))]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "button is-primary",
              class: { "is-loading": _vm.isModalLoading },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.confirm()
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("submit_button_label")))]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1085ce83", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1085ce83","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Doctor/RecommendationsModal.vue
// module id = 801
// module chunks = 1